/* eslint-disable */
import { useState } from "react";
import DOMPurify from "dompurify";
import {
  Box, Button, Card, CircularProgress, Container, Dialog, DialogActions,
  DialogContent, DialogTitle, Divider, Grid, IconButton, Tab, Tabs, Typography,
  styled, useTheme,
} from "@mui/material";
import { Close as CloseIcon, Schedule as ScheduleIcon } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import JoditEditor from "jodit-react";
import { useMutation } from "@apollo/client";
import { PUBLISH_BLOG_SHOPIFY, PUBLISH_BLOG_WORDPRESS } from "../../gql/mutations/userWebSiteVisit";
import { SCHEDULE_POST } from "../../gql/mutations/scrapy";
import { usePopup } from "../../context/commonPop";
import { GetProjectByUserId } from "../../hooks/userWebsiteData";
import { height } from "@mui/system";

const SectionWrapper = styled("section")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: "30px 0",
  paddingTop: "0",
  "& .SomethingWrong": {
    color: theme.palette.text.primary,
  },
  "& .AccordionListWrapper": {
    "& .MuiAccordion-root": {
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "10px",
      marginBottom: "10px",
      "&::before": {
        display: "none",
      },
      "& .MuiAccordionSummary-root": {
        "& .MuiAccordionSummary-content": {
          "& p": { wordBreak: "break-all" },
        },
      },
      "& .MuiAccordionDetails-root": {
        "& .KeywordListWrapper": {
          "& .MainHeading": {
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "18px",
            "&.VerifiedKeywords": {
              marginTop: "22px",
            },
          },
          "& .NotFoundWrapper": {
            padding: "10px 0 10px",
            "& h5": {
              textAlign: "center",
              fontSize: "14px",
            },
          },
          "& .KeywordListInner": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            gap: "15px",
            maxHeight: "200px",
            overflowY: "auto",
            "@media screen and (max-width: 600px)": {
              flexDirection: "column",
              flexWrap: "nowrap",
              alignItems: "flex-start",
            },
            "&::-webkit-scrollbar-track": {
              borderRadius: "10px",
              backgroundColor: theme.palette.text.primary + "0d",
            },
            "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
              backgroundColor: theme.palette.primary.main,
            },
            "& span.Tags": {
              backgroundColor: theme.palette.primary.main + "1a",
              fontSize: "12px",
              padding: "3px 14px 3px",
              borderRadius: "12px",
              color: theme.palette.primary.main,
            },
          },
        },
      },
    },
  },
  "& .PaginationWrapper": {
    marginTop: "25px",
    "& nav": {
      "& ul": {
        justifyContent: "flex-end",
        "@media screen and (max-width: 600px)": {
          justifyContent: "center",
        },
        "& li": {
          "& button": {
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main + "2b",
              color: theme.palette.primary.main,
            },
          },
          "@media screen and (max-width: 600px)": {
            "&:first-of-type, &:last-of-type": {
              display: "none",
            },
          },
        },
      },
    },
  },

  "& .KeywordsWrapper": {
    "& .GuidTabelWrapper": {
      marginBottom: "50px",
      "& .datagridnopage": {
        border: "2px solid" + theme.palette.divider,
        marginTop: "20px",
        "& .MuiDataGrid-main": {
          "& .MuiDataGrid-columnHeaders": {
            borderColor: theme.palette.divider,
            borderWidth: "2px",
            "& .MuiDataGrid-columnSeparator": {
              color: theme.palette.text.primary + "26",
              visibility: "visible",
            },
            "& .MuiDataGrid-columnHeadersInner": {
              width: "100%",
              '& div[role="row"]': {
                width: "100%",
                "& .MuiDataGrid-columnHeader": {
                  flex: 1,
                  width: "auto !important",
                  maxWidth: "unset !important",
                  outline: "none !important",
                  "&:first-of-type": { maxWidth: "100px !important", "& .MuiDataGrid-columnHeaderTitleContainer": { justifyContent: "left" } },
                  "&:last-of-type": { maxWidth: "170px !important", "& .MuiDataGrid-columnHeaderTitleContainer": { justifyContent: "left" } },
                  // "&:nth-last-child(2)": { maxWidth: "200px !important", "& .MuiDataGrid-columnHeaderTitleContainer": { justifyContent: "left" } },
                  "& .MuiDataGrid-columnHeaderTitleContainer": { justifyContent: "start" },
                },
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px",
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            },
          },
          "& .MuiDataGrid-virtualScroller": {
            "&::-webkit-scrollbar-track": {
              borderRadius: "10px",
              backgroundColor: theme.palette.text.primary + "0d",
            },
            "&::-webkit-scrollbar": { width: "6px", backgroundColor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
              backgroundColor: theme.palette.primary.main,
            },
            "& .MuiDataGrid-virtualScrollerContent": {
              height: "264px!important",
              "& .MuiDataGrid-virtualScrollerRenderZone": {
                "& .MuiDataGrid-row": {
                  boxShadow: "inset 0px 1px " + theme.palette.divider,
                  minHeight: "70px !important",
                  maxHeight: "unset !important",
                  border: "none",
                  "&.AddonKeywordRow": { minHeight: "182px!important" },
                },
                width: "100%",
                '& div[role="row"]': {
                  width: "100%",
                  cursor: "pointer",
                  "& .MuiDataGrid-cell": {
                    minHeight: "70px !important",
                    maxHeight: "unset !important",
                    flex: 1,
                    width: "auto !important",
                    maxWidth: "unset !important",
                    justifyContent: "start",
                    borderColor: theme.palette.divider,
                    "&:focus-within": { outline: "none" },
                    "&:first-of-type": { maxWidth: "100px !important", justifyContent: "left" },
                    "&:nth-last-child(2)": { maxWidth: "170px !important", justifyContent: "left" },
                    // "&:nth-last-child(3)": { maxWidth: "200px !important", justifyContent: "left" },
                    "&:last-child": {
                      display: "none",
                    },

                    "& .AddonInnerListWrapper": {
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      "& .AddonLabel": {
                        fontWeight: 900,
                      },
                      "& ul": {
                        marginTop: "10px",
                        marginBottom: "5px",
                        paddingLeft: "15px",
                        "& li": {
                          marginBottom: "5px",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          minWidth: "275px",
                          gap: "8px",
                          "& .AddonColor": {
                            backgroundColor: "#ff0000",
                            width: "20px",
                            height: "20px",
                            borderRadius: "5px",
                            "&.AddonColor0": { backgroundColor: "#cc8400" },
                            "&.AddonColor1": { backgroundColor: "#b8cc00" },
                            "&.AddonColor2": { backgroundColor: "#00cc8c" },
                            "&.AddonColor3": { backgroundColor: "#0094cc" },
                            "&.AddonColor4": { backgroundColor: "#763EBD" },
                          },
                        },
                      },
                    },
                    "& .FocusKeyword": {
                      backgroundColor: "#008000",
                      width: "20px",
                      height: "20px",
                      borderRadius: "5px",
                    },
                  },
                  "& .MuiDataGrid-cellContent": {
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                  },
                },
              },
            },
          },
        },
        "& .MuiDataGrid-footerContainer": {
          display: "none",
          borderColor: theme.palette.divider,
          "& .MuiTablePagination-toolbar": {
            "& > p": { marginBottom: "0" },
          },
        },
      },
    },
    "& .WordCountWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "40px",
      marginTop: "10px",
      "& h3": { fontSize: "24px", fontWeight: 700 },
      "& p": {
        textAlign: "right",
        color: theme.palette.primary.main,
      },
    },
    "& .FindInputWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "15px",
      // marginBottom: "30px",
      "& .InputStyleWrapper": {
        flex: "1",
        "& .selectWrapper": {
          color: theme.palette.text.primary,
          "& .MuiOutlinedInput-root": {
            "&:hover": {
              border: "none !important",
              outline: "none",
            },
          },
          "&::placeholder": {
            color: theme.palette.text.primary,
          },
          "& input": {
            color: theme.palette.text.primary,
            "&:hover": {
              border: `none `,
              borderRadius: "5px",
            },
          },
        },
      },
      "& .GenerateBtn": {
        padding: "10px 20px 10px",
      },
    },
    "& .BlogGenerateWrapper": {
      "& img": {
        width: "100%",
        height: "auto",
      },
      "& .focus": {
        backgroundColor: "#008000",
        color: "#ffffff",
        borderRadius: "3px",
        padding: "0 5px",
      },
      "& .addon01": { backgroundColor: "#cc8400", color: "#ffffff", borderRadius: "3px", padding: "0 5px" },
      "& .addon02": { backgroundColor: "#b8cc00", color: "#ffffff", borderRadius: "3px", padding: "0 5px" },
      "& .addon03": { backgroundColor: "#00cc8c", color: "#ffffff", borderRadius: "3px", padding: "0 5px" },
      "& .addon04": { backgroundColor: "#0094cc", color: "#ffffff", borderRadius: "3px", padding: "0 5px" },
      "& .addon05": { backgroundColor: "#763EBD", color: "#ffffff", borderRadius: "3px", padding: "0 5px" },
      "& .TabLabelWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginBottom: "35px",
        "& button.MuiTab-root": {
          "&:focus": {
            outline: "none",
          },
        },
      },
    },
  },
}));

const MetaTableRowss = [
  { id: 1, type: "Focus Keyword", count: "0" },
  { id: 2, type: "Addon Keyword", count: "0" },
];

function GetBlog({ htmlData, heading, MetaTableRows, selectedAddon, selectedFocus, projectId, selectedFocusKeywords }) {
  const theme = useTheme();
  const { handleOpen } = usePopup();

  const { allProjectWithSessionId } = GetProjectByUserId({ RequireSessionId: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [content, setContent] = useState(htmlData.text_html);
  const customizer = useSelector(state => state.customizer);
  const [publishBlogShopify] = useMutation(PUBLISH_BLOG_SHOPIFY);
  const [publishBlogWordpress] = useMutation(PUBLISH_BLOG_WORDPRESS);
  const [schedulePost, { loading: scheduling }] = useMutation(SCHEDULE_POST);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const [scheduledAt, setScheduledAt] = useState(dayjs().add(1, "hour"));

  const MetaTableColumns = [
    { field: "id", headerName: "No." },
    {
      field: "type",
      headerName: "Keyword Type",
      renderCell: params => (
        <Box className="AddonInnerListWrapper">
          {params?.row?.type === "Addon Keyword" ? (
            <>
              <Box className="AddonLabel">{params.value}</Box>
              {selectedAddon && (
                <Box component="ul">
                  {selectedAddon.map((item, ind) => (
                    <Box component="li">
                      <Box className={`AddonColor${ind} AddonColor`}></Box>
                      {item}
                    </Box>
                  ))}
                </Box>
              )}
            </>
          ) : params?.row?.type === "Focus Keyword" ? (
            <>
              <Box className="AddonLabel">{params.value}</Box>
              {selectedFocus.length > 0 ? (
                <Box component="ul">
                  {selectedFocus.map((item, ind) => (
                    <Box component="li">
                      <Box className={`FocusKeyword${ind} FocusKeyword`}></Box>
                      {item}
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box component="ul">
                  {selectedFocusKeywords.length > 0 &&
                    selectedFocusKeywords.map((item, ind) => (
                      <Box component="li">
                        <Box className={`FocusKeyword${ind} FocusKeyword`}></Box>
                        {item}
                      </Box>
                    ))}
                </Box>
              )}
            </>
          ) : (
            <Box>{params.value}</Box>
          )}
        </Box>
      ),
    },
    { field: "count", headerName: "Keyword Count" },
  ];
  const projectData = allProjectWithSessionId.find(project => project.id === projectId);

  const hasShopifyProject = projectData && projectData.appType === "Shopify" && projectData.isConnected;
  const hasWordpressProject = projectData && projectData.appType === "Wordpress" && projectData.isConnected;

  const handlePublish = async () => {
    setIsLoading(true);
    try {
      const filteredProject = allProjectWithSessionId.find(project => project.id === projectId);
      if (!filteredProject) {
        console.error("Project not found");
        return;
      }

      const { appType, website, isConnected } = filteredProject;
      if (appType === "Shopify" && isConnected) {
        const { data } = await publishBlogShopify({
          variables: {
            inputdata: {
              body: content,
              description: "testing",
              projectId,
              title: heading,
            },
          },
        });
        if (data) {
          setIsLoading(false);
          handleOpen(true, "Blog Published Successfully");
        }
      } else if (appType === "Wordpress" && isConnected) {
        const { data } = await publishBlogWordpress({
          variables: {
            inputdata: {
              body: content,
              description: "Testing Description For Blog Upload",
              projectId,
              domain: website,
              title: heading,
            },
          },
        });
        if (data) {
          setIsLoading(false);
          handleOpen(true, "Blog Published Successfully");
        }
      } else {
        console.error("Unsupported apptype:", appType);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error publishing blog:", error);
    }
  };

  const handleSchedule = async () => {
    if (!scheduledAt || !scheduledAt.isValid() || scheduledAt.isBefore(dayjs())) {
      handleOpen(false, "Please select a future date and time");
      return;
    }
    try {
      await schedulePost({
        variables: {
          input: {
            projectId,
            title: heading,
            body: content,
            description: "",
            publishAt: scheduledAt.toISOString(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        },
      });
      handleOpen(true, "Blog scheduled successfully");
      setScheduleOpen(false);
    } catch (error) {
      handleOpen(false, error.message || "Failed to schedule blog");
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleEditButton = () => {
    if (content && typeof content === "object") {
      setContent(prev => {
        return prev.trim().replace(/\n/g, "");
      });
    }
  };

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={0} mt={0}>
            <Grid item xs={12} md={12}>
              <Card sx={{ padding: { xs: "15px 15px 50px 15px", sm: "30px 45px 40px 40px" }, border: `1px solid ${theme.palette.divider}`, boxShadow: "none" }}>
                <Box className="KeywordsWrapper">
                  <Box className="GuidTabelWrapper">
                    <DataGrid
                      getRowClassName={params => (params.row.type === "Addon Keyword" ? "AddonKeywordRow" : "")}
                      rows={MetaTableRows || MetaTableRowss}
                      columns={MetaTableColumns}
                      className="datagridnopage"
                      pageSize={5}
                      disableSelectionOnClick
                    />
                  </Box>

                  <Box className="WordCountWrapper">
                    <Typography component="h3">{heading}</Typography>
                    <Typography component="p">
                      <strong>Word Count:</strong> {htmlData.word_count}
                    </Typography>
                  </Box>

                  <Box className="BlogGenerateWrapper">
                    <Box className="TabLabelWrapper">
                      <Tabs value={tabValue} onChange={handleTabChange}>
                        <Tab label="Preview" />
                        <Tab label="Edit" onClick={handleEditButton} disabled={!hasShopifyProject && !hasWordpressProject} />
                      </Tabs>
                      {isLoading ? (
                        <CircularProgress style={{ width: "20px", height: "20px" }} />
                      ) : (
                        <Box className="PublishBtnWrapper" sx={{ display: "flex", gap: 1 }}>
                          <Button onClick={handlePublish} disabled={!hasShopifyProject && !hasWordpressProject}>
                            Publish
                          </Button>
                          <Button
                            variant="outlined"
                            startIcon={<ScheduleIcon />}
                            onClick={() => setScheduleOpen(true)}
                            disabled={!hasShopifyProject && !hasWordpressProject}
                            sx={{ textTransform: "none" }}
                          >
                            Schedule
                          </Button>
                        </Box>
                      )}
                    </Box>
                    {tabValue === 0 ? (
                      <>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
                      </>
                    ) : (
                      <>
                        <JoditEditor value={content} onChange={setContent} tabIndex={1} />
                      </>
                    )}
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* Schedule Dialog */}
      <Dialog
        open={scheduleOpen}
        onClose={() => setScheduleOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px" } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <ScheduleIcon color="primary" fontSize="small" />
              <Typography variant="h6" fontWeight={700}>Schedule Post</Typography>
            </Box>
            <IconButton onClick={() => setScheduleOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 3 }}>
          <Box mb={2}>
            <Typography variant="caption" color="text.secondary" display="block">Post Title</Typography>
            <Typography variant="subtitle2" fontWeight={600}>{heading}</Typography>
            {projectData && (
              <Typography variant="caption" color="text.secondary">
                {projectData.projectName || projectData.website} ({projectData.appType})
              </Typography>
            )}
          </Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Publish Date & Time"
              value={scheduledAt}
              onChange={(val) => setScheduledAt(val)}
              disablePast
              slotProps={{
                textField: {
                  fullWidth: true,
                  helperText: `Timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
                },
              }}
            />
          </LocalizationProvider>
          {scheduledAt && scheduledAt.isValid() && scheduledAt.isAfter(dayjs()) && (
            <Box mt={2} sx={{ backgroundColor: theme.palette.primary.light + "15", borderRadius: "8px", p: 1.5, border: `1px solid ${theme.palette.primary.light}` }}>
              <Typography variant="body2" color="primary.main" fontWeight={500}>
                Will publish on {scheduledAt.format("dddd, MMMM D, YYYY [at] h:mm A")}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setScheduleOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSchedule}
            disabled={scheduling}
            startIcon={scheduling ? <CircularProgress size={16} /> : null}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: "8px" }}
          >
            {scheduling ? "Scheduling..." : "Schedule Post"}
          </Button>
        </DialogActions>
      </Dialog>
    </SectionWrapper>
  );
}

export default GetBlog;
